import { jsx } from "react/jsx-runtime";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
function BuyAgainLink(props) {
  if (!props.entry) return null;
  const entry = props.entry;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [entry.active_state.active_state_link.title]
        }
      },
      children: /* @__PURE__ */ jsx(
        Link,
        {
          "data-testid": entry.active_state.active_state_link.title,
          href: entry.active_state.active_state_link.href,
          variant: "t6",
          children: entry.active_state.active_state_link.title
        }
      )
    }
  );
}
export {
  BuyAgainLink
};
